import React from "react";

const Separator = () => {
  return <div className="separator"></div>;
};

export default Separator;
